import { render } from "./FicheCours.vue?vue&type=template&id=6fa8a535&scoped=true"
import script from "./FicheCours.vue?vue&type=script&lang=js"
export * from "./FicheCours.vue?vue&type=script&lang=js"

import "./FicheCours.vue?vue&type=style&index=0&id=6fa8a535&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fa8a535"]])

export default __exports__